module.exports = __webpack_public_path__ + "img/8 storing.99415319.jpeg";